// extracted by mini-css-extract-plugin
export default {"holder":"Spinner_holder__MxM6j","spinnerStyle":"Spinner_spinnerStyle__X9yT1","spinner":"Spinner_spinner__Qz7DP"};